import React from 'react'
import './Comentarios.css'
export default function Comentarios() {
    return (
        <div className='comentariosContain'>

            <form action="" className='formComentario'>
                <textarea name="" id="" cols="30" rows="10" placeholder='Deja un comentario'>

                </textarea>

                <button type="button">
                    Enviar
                </button>
            </form>

        </div>
    )
}
